define(function() {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/core/autocomplete/metadata/{0}',
		url: function() {
			return this.urlRoot.format(this.moniker);
		}
    });
});
